import { render } from "./d3-scatter.vue?vue&type=template&id=62f7348f&scoped=true&ts=true"
import script from "./d3-scatter.vue?vue&type=script&lang=ts"
export * from "./d3-scatter.vue?vue&type=script&lang=ts"

import "./d3-scatter.vue?vue&type=style&index=0&id=62f7348f&lang=less"
import "./d3-scatter.vue?vue&type=style&index=1&id=62f7348f&scoped=true&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f7348f"]])

export default __exports__